module.exports = __webpack_public_path__ + "static/img/couponH.96b287f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/couponH.png
// module id = g3lV
// module chunks = 83